import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { REFRESH_INDEXED } from 'src/app/core/indexedDB/helpers/enums.enums';
import { IndexedDBDexieService } from 'src/app/core/indexedDB/service/indexed-db-dexie.service';
import { localDB } from 'src/app/shared/helpers/localStorage';
import { GenericResponse } from 'src/app/shared/interfaces/generic.interface';
import { environment as env } from 'src/environments/environment';
import { CollaboratorMarksResponse, response_getmarks, update_location_data, Location } from '../interfaces/interfaces';
@Injectable({
  providedIn: 'root'
})
export class IntervalService{
  eventSubject = new BehaviorSubject<boolean>(false);
  eventSubjectMarks = new BehaviorSubject<boolean>(false);
  eventSubjectDasboard = new BehaviorSubject<boolean>(false);
  eventSubjectLocation = new BehaviorSubject<Location| null>(null);
  event$ = this.eventSubject.asObservable();
  eventMarks$ = this.eventSubjectMarks.asObservable();
  eventUpdateDasboard$ = this.eventSubjectDasboard.asObservable();
  eventLocation$ = this.eventSubjectLocation.asObservable();

  constructor(
    private readonly _indexDB: IndexedDBDexieService,
    private readonly http: HttpClient,
  ) {}

  MyGeolocation(geolocation: Location): void{
    this.eventSubjectLocation.next(geolocation);
  }

  ReloadDashboard(isReloadDashboard: boolean = false): void {
    this.eventSubjectDasboard.next(isReloadDashboard);
  }

  ReloadMarks(isReloadMarks: boolean = false): void {
    this.eventSubjectMarks.next(isReloadMarks);
  }

  ReloadLocalDB(isReload: boolean = false): void {
    this.eventSubject.next(isReload);
  }

  getUserSchedule(dFecha_Jornada:string) {
    return this._indexDB.getRequestData<GenericResponse<CollaboratorMarksResponse>>(`api/marcas/marks-colaborador?dfecha_jornada=${dFecha_Jornada}`, 'endpoints', REFRESH_INDEXED.EVERY_REFRESH).pipe(
      map(resp=>{
        localDB.removeItem('V-HORARIO');
        localDB.setItem('V-HORARIO', JSON.stringify(resp.data))
        return resp
      })
    );
  }

  getScheduleForExtemp(dFecha_Jornada:string){
    return this.http.get<GenericResponse<CollaboratorMarksResponse>>(`${env.api_url}api/marcas/marks-colaborador?dfecha_jornada=${dFecha_Jornada}`).pipe(
      map(res => {
        return res
      })
    )
  }

  getMarksUser(nId_Colab:number, dFecha_Jornada:string, sendLocaldb:boolean = false, bIsExtemp:boolean = false){
    const url = `${env.api_url}api/marcas/get-marks-created?nid_colaborador=${nId_Colab}&dfecha_jornada=${dFecha_Jornada}&bIsExtemp=${bIsExtemp}`
    return this.http.get<GenericResponse<response_getmarks>>(url).pipe(
      map(res => {
        if(sendLocaldb){
          localDB.removeItem('Intervals');
          localDB.removeItem('marks-user');
          localDB.setItem('marks-user', JSON.stringify(res))
          localDB.setItem('Intervals', JSON.stringify(res.data))
        }
        return res
      })
    );
  }

  UpdateLocation(location: update_location_data){
    const url = `${env.api_url}api/marcas/Update_location`;
    return this.http.post<any>(url, location).pipe(
      map(resp=>{
          return resp
      })
    );
  }

}
